/* 用章管理接口 */
import { $post } from '@/api/request'

// 列表查询
export function query (data = {}) {
  return $post({
    url: '/compApplyStamp/query',
    data
  })
}
// 列表查询
export function update (data = {}) {
  return $post({
    url: '/compApplyStamp/update',
    data
  })
}
// 查询自己创建的
export function queryMine (data = {}) {
  return $post({
    url: '/compApplyStamp/queryMine',
    data
  })
}
// 查询需要我审批的
export function queryMyAudit (data = {}) {
  return $post({
    url: '/compApplyStamp/queryMyAudit',
    data
  })
}
// 发起用章审核
export function submitApply (data = {}) {
  return $post({
    url: '/compApplyStamp/submitApply',
    data
  })
}
// 已审批
export function listApplyAudited (data = {}) {
  return $post({
    url: '/compApplyStamp/listApplyAudited',
    data
  })
}
// 暂存
export function stagingApply (data = {}) {
  return $post({
    url: '/compApplyStamp/stagingApply',
    data
  })
}
// 催批
export function sendSmsAuditPersonAgain (data = {}) {
  return $post({
    url: '/compApplyStamp/sendSmsAuditPersonAgain',
    data
  })
}

// 获取用章申请详情
export function getApplyDetail (data = {}) {
  return $post({
    url: '/compApplyStamp/getApplyDetail',
    data
  })
}

// 用章审核
export function audit (data = {}) {
  return $post({
    url: '/compApplyStamp/audit',
    data
  })
}
// 用章审核
export function auditAndNextUser (data = {}) {
  return $post({
    url: '/compApplyStamp/auditAndNextUser',
    data
  })
}

// 查询是否是预警合同
export function queryContractStatus (data = {}) {
  return $post({
    url: '/contractInfo/queryWarnContractByNumber',
    data
  })
}

// 查询合同列表
export function queryContracts (val) {
  return $post({
    url: `/contractFiling/queryListByCategory?category=${val}`
  })
}
